export enum Theme {
  HIGH_CONTRAST_CLASS = 'high-contrast',
  DARK_CLASS = 'theme-dark'
}